module.exports = __webpack_public_path__ + "img/cszl-3.2bea57bc.png";